import { render } from "./MapNew.vue?vue&type=template&id=4f536570"
import script from "./MapNew.vue?vue&type=script&lang=js"
export * from "./MapNew.vue?vue&type=script&lang=js"

import "./MapNew.vue?vue&type=style&index=0&id=4f536570&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__